import { render, staticRenderFns } from "./StandardLogin.vue?vue&type=template&id=3611d946&scoped=true"
import script from "./StandardLogin.vue?vue&type=script&lang=js"
export * from "./StandardLogin.vue?vue&type=script&lang=js"
import style0 from "./StandardLogin.vue?vue&type=style&index=0&id=3611d946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3611d946",
  null
  
)

export default component.exports